export const BR_CONSTANTS = {
    SOFT_COST_MULTIPLIER: 1.15,
    LOSS_OF_GROSS_EARNINGS_MULTIPLIER: 1.25,
    LOSS_OF_RENTAL_INCOME_MULTIPLIER: 1.25,
    BASE_RATE: 0.38,
};
